// @ts-nocheck
let _draft: { id: number; type: string } | null = null;

export function setDraftDocument(draft: { id: number; type: string }) {
  _draft = draft;
}

export function getDraftDocument() {
  return _draft;
}

export function clearDraftDocument() {
  _draft = null;
}
